const LABEL_IDS_TO_FILTER_PATH = ['filters', 'checkedLabelIds'];

export default moduleName => [moduleName, ...LABEL_IDS_TO_FILTER_PATH];
